module.exports = __webpack_public_path__ + "static/media/299.de63e162.svg";